import React from "react";
import { FontStyles } from "../../utils/font-styles.ts";
import { SectionHeader } from "../../components/section-header.tsx";
import { ButtonLink } from "../../components/buttons/button-link.tsx";
import { PropertyCard, PropertyCardProps } from "../../components/property-card/property-card.tsx";

export type Property = Omit<PropertyCardProps, "image"> & { image: string };

export interface LatestPropertiesForSaleProps {
  properties: Property[];
  orgId: number; // needed for url
}

export const LatestPropertiesForSale: React.FC<LatestPropertiesForSaleProps> = ({ properties, orgId }) => {
  return (
    <div className={"flex flex-col gap-4.5"}>
      <SectionHeader text={"Properties for sale"} as="h2" className={`leading-none md:leading-none ${FontStyles.h5}`} />
      <div className="flex flex-col md:grid md:grid-cols-3 gap-4.5">
        {properties.map((property) => {
          //we are generating the image object here instead of using the PropertyCardProps as a prop to allow for
          //backwards compatibility with the current data structure in the chartered firm page, this should
          //be updated in the future, mirroring the implementation in the recently-viewed-properties.tsx component
          const type = property.type || "Property";
          const propertyAltText = property.address ? `${type} for sale at ${property.address}` : `${type} for sale`;
          const propertyCardProps: PropertyCardProps = {
            ...property,
            image: {
              altText: propertyAltText,
              sources: [{ width: 800, url: property.image }],
            },
          };
          return <PropertyCard {...propertyCardProps} key={property.id} />;
        })}
      </div>
      <ButtonLink
        label={"View all agent properties"}
        variant={"outlined"}
        colorVariant={"secondary"}
        href={`/properties?orgId=${orgId.toString()}`}
      />
    </div>
  );
};
